export enum ToolInputEnum {
  WORKFLOW = 'Workflow',
  FILE = 'File',
  ASSISTANT = 'Assistant',
  FILES = 'FILE',
  SELECTION = 'SELECTION',
  GENERAL_LEDGER = 'GENERAL_LEDGER',
  SELECTION_AND_FILE = 'SELECTION_AND_FILE'
}
